
import { Component, Vue } from "vue-property-decorator";
import {
  ORDER_MENU_ITEM,
  TRUCK_MENU_ITEM,
  DISPATCH_SHORTCUT,
  DISPATCH_ORDER_SETTINGS,
  DISPATCH_TRUCK_SETTINGS
} from "@/consts";
import DispatchOrdersTable from "@/components/order/DispatchOrdersTable.vue";
import OrderActions from "@/components/order/OrderActions.vue";
import TrucksTable from "@/components/TrucksTable.vue";
import TrucksActions from "@/components/truck/TrucksActions.vue";
import TruckFilters from "@/components/truck/TruckFilters.vue";
import notifications from "../lib/notifications";
import { getModule } from "vuex-module-decorators";
import { OrderModule, TruckModule, AccountModule } from "@/store/modules/index";
import { GetTrucksRequest } from "@/models/api/trucks/getTrucks";

const orderModule = getModule(OrderModule);
const truckModule = getModule(TruckModule);
const accountModule = getModule(AccountModule);

@Component({
  components: {
    DispatchOrdersTable,
    OrderActions,
    TrucksTable,
    TrucksActions,
    TruckFilters
  }
})
export default class Orders extends Vue {
  loadingMoreOrders: boolean = false;
  currentTruckPage: number = 1;
  pageSize: number = 0;
  localOrderData: any = null;
  showFilter: boolean = false;
  showReceiveOrder: boolean = false;
  showTrucks: boolean = false;
  showOrderFields: boolean = false;
  showTruckFields: boolean = false;
  showOrderFieldFilter: boolean = false;
  showTruckFieldFilter: boolean = false;
  orderClickLocation: any = null;
  truckClickLocation: any = null;
  truckMenuStyle: string = "";
  ordersMenuStyle: string = "";
  selectedTruck: Array<any> = [];
  selectedOrder: Array<any> = [];
  dragSrcRow: any = null;
  srcTable: string = "";
  rows: Array<any> = [];
  rows2: Array<any> = [];
  orders: any = null;
  trucks: any = null;
  truckAction: string = "";
  orderAction: string = "";
  shortcuts: any = DISPATCH_SHORTCUT;
  ORDER_MENU_ITEM: any = ORDER_MENU_ITEM;
  TRUCK_MENU_ITEM: any = TRUCK_MENU_ITEM;
  DISPATCH_ORDER_SETTINGS: any = DISPATCH_ORDER_SETTINGS;
  DISPATCH_TRUCK_SETTINGS: any = DISPATCH_TRUCK_SETTINGS;
  loadingProgress: number = 10;
  loadingMax: number = 100;
  activeFilters: Object = {};

  get sortOrder() {
    // sortOrder: state => state.order.sortOrder,
    return orderModule.dataSortKey;
  }

  get truckFields() {
    return truckModule.truckFields;
  }

  get orderData() {
    return orderModule.data;
  }

  get orderPageData() {
    return orderModule.pageData;
  }

  get truckData() {
    return truckModule.data;
  }

  get truckPageData() {
    return truckModule.pageData;
  }

  get truckLoading() {
    return truckModule.loading;
  }

  get hideManifestedOrder() {
    return orderModule.hideManifestedOrder;
  }

  get showOnlyScheduledOrders() {
    return orderModule.showOnlyScheduledOrders;
  }

  get showOnlyIncorrectTruck() {
    return orderModule.showOnlyIncorrectTruck;
  }

  get menuItemsToDisplay() {
    return this.ORDER_MENU_ITEM;
  }

  async exportOrders() {
    try {
      let result = await orderModule.exportOrders();
      return result;
    } catch (ex) {
      notifications.error("Order List", "Failed to export orders", ex);
    }
  }

  async mounted() {
    orderModule.resetOrders();
    await accountModule.getSavedOrderSearches();

    if (this.$route.query.alert)
      accountModule.setAlertTypeFilter({
        alertType: this.$route.query.alert,
        facilityCodes: this.$route.query.facilityCodes,
        deliveryForIds: this.$route.query.deliveryForIds
      });

    this.reloadDispatchBoard();

    truckModule.getTrucks(null);

  }

  async onFilter() {
    await this.reloadDispatchBoard();
  }

  async onSort(s) {
    orderModule.applyOrderListSort(s);
  }

  async reloadDispatchBoard() {
    try {
      await orderModule.reloadOrders();
    } catch (ex) {
      notifications.error("Order List", "Failed to load orders", ex);
    }
  }

  async loadMoreOrders() {
    try {
      await orderModule.loadOrders(null);
    } catch (ex) {
      notifications.error("Order List", "Failed to load additional orders", ex);
    }
  }

  loadMoreTrucks() {
    try {
      truckModule.setLoading(true);
      truckModule.getTrucks(null);
    } catch (ex) {
      notifications.error("Truck List", "Failed to load additional trucks", ex);
    } finally {
      truckModule.setLoading(false);
    }
  }

  toggleChangeTruckField(idx, hideShow) {
    const bool = hideShow ? true : false;
    truckModule.toggleTruckField({ idx: idx, value: bool });
  }

  updateSelectedTruck(selectedTruck) {
    this.selectedTruck = selectedTruck;
  }
}
